import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

//-------------------Pages
import NotFound404 from "../components/pages/NotFound404";

import Portfolio from "../components/pages/portfolio/Portfolio.jsx";
import BlogPost from "../components/pages/blog/BlogPost";

//-------------------Templates--------------------------------
import BlogSite from "../components/pages/blog/BlogSite.jsx";

const Routes = () => {
	return (
		<Router>
			<Switch>
				{/* portfolio */}
				<Route exact path="/" component={Portfolio} />
				{/* Blog */}
				<Route exact path="/blog" component={BlogSite} />
				<Route exact path="/blogpost/:id/" component={BlogPost} />
				<Route component={NotFound404} />
			</Switch>
		</Router>
	);
};

export default Routes;
